import React, { useState, useEffect } from 'react';
import { ImagesLoader } from '../../smart/utils/images-loader/ImagesLoader';
import { Loader } from '../utils/loader/Loader';
import './financialsolutionarea.scss';

type props = {}

export const FinancialSolutionArea = (props: any) => {

    const [isOnline, setIsOnline] = useState(false);

    useEffect(() =>

        setIsOnline(true), [setIsOnline]
    );

    if (isOnline === false) {
        return <Loader />;
    }
    else
        return <div className="financial_solution_area">
            <div className="container">
                <div className="row">
                    <div className="col-xl-6 col-lg-6">
                        <div className="financial_active owl-carousel">
                            <div className="single_finalcial_wrap">
                                <h3>Infront Italia <br />
                        </h3>
                                <p>diventata negli anni un information provider di riferimento per il mercato italiano è nata come divisione interna a
                                    Borsa Italiana e ora parte integrante in Infront ASA.<br /><br />

L’informazione finanziaria è il cuore del nostro Business. Esperienza, competenza e passione per la tecnologia sono
gli elementi fondamentali che guidano la realizzazione dei nostri servizi.<br /><br />

Siamo attenti alle esigenze dei nostri clienti, pertanto la nostra proposta comprende sia servizi di trading che servizi
informativi, altamente personalizzabili, e veicolati attraverso tutti i possibili canali, dalle piattaforme professionali ai
mobile device.<br /><br />

Forniamo alle principali istituzioni finanziarie, ai data vendors e alle società quotate un’ampia gamma di servizi
informativi:<br /><br />

Flussi quotazioni in tempo reale/ritardato di tutti i principali mercati nazionali e internazionali

Terminali Client Server

Piattaforme Browser Based

Flussi dati storici, anagrafici e documentali</p>
                            </div>
                            <div className="single_finalcial_wrap">
                                <h3>Infront ASA <br />
                            
                        </h3>
                                <p>Società indipendente nata nel 1998<br /><br />
                                Quotata alla Borsa di OSLO dal 2017<br /><br />
                                Offre dati di mercato globali, notizie, strumenti di analisi e trading, soluzioni di gestione del portafoglio e advisory, soluzioni data feeds, compliance regolamentare, soluzioni di distribuzione e pubblicazione dei dati <br /><br />
                                3.600 clienti e oltre 90.000 utilizzatori professionali <br /><br />
Uffici in 14 Paesi </p>
                            </div>
                            {/* <div className="single_finalcial_wrap">
                                <h3>Gives you the best Financial <br />
                            solution for business
                        </h3>
                                <p>These cases are perfectly simple and easy to distinguish. In a free hour, when our power of choice is untrammelled and when nothing prevents our being able to do what we like best.</p>
                            </div> */}
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-6">
                        <div className="finance_thumb">
                            <img src={ImagesLoader.FSA_first} alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
}